/* @flow */
import Helmet from 'react-helmet'
import React from 'react'


const Description = ({ message, values }: any) => {
  return (
    <Helmet
      meta={[
        { name: 'description', content: message },
      ]}
    />
  )
}

Description.propTypes = {
  message: React.PropTypes.oneOfType([
    React.PropTypes.object,
    React.PropTypes.string,
  ]).isRequired,
  values: React.PropTypes.object,
}

export default Description



// WEBPACK FOOTER //
// ./src/browser/components/Description.js